module.exports = __webpack_public_path__ + "static/media/loader.478c8359.gif";